module.exports = __webpack_public_path__ + "static/img/li_02.a93766b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/li_02.jpg
// module id = t5yt
// module chunks = 0